import { useParams } from "react-router-dom";
import { useEffect } from "react";
import VnvAssistChat from "./VnvAssistChat";
import { useVnvAssistStore } from "./store/VnvAssistStore";
import AtomAssistPageLoad from "src/views/assistant/components/AtomAssistPageLoad";
import { useSetVnvAssistConfig } from "src/views/assistant/hooks/useProductConfig";
import { useChatStore } from "src/views/assistant/stores/ChatStore";

interface VnvAssistChatPageParams {
  vnv_run_id: string;
  dialogueId: string;
}

const VnvAssistChatPage = () => {
  const { vnv_run_id, dialogueId: dialogueIdParam } =
    useParams<VnvAssistChatPageParams>();

  const vnvRunId = vnv_run_id ? Number(vnv_run_id) : undefined;
  const dialogueId = dialogueIdParam ? Number(dialogueIdParam) : undefined;

  const { initialUserMessage } = useChatStore();

  useEffect(() => {
    if (vnvRunId) useVnvAssistStore.setState({ vnvRunId });
    if (dialogueId) useVnvAssistStore.setState({ dialogueId });
  }, [vnvRunId, dialogueId]);

  useSetVnvAssistConfig();

  if (!vnvRunId || !dialogueId) {
    return <AtomAssistPageLoad />;
  }

  return (
    <VnvAssistChat
      vnvRunId={vnvRunId}
      dialogueId={dialogueId}
      initialUserMessage={initialUserMessage}
    />
  );
};

export default VnvAssistChatPage;
